import './instrument';
import * as React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import Hotjar from '@hotjar/browser';
import { BackendFetchContextProvider } from 'src/lib/BackendFetchContext';
import { createBackendApiFetch } from 'src/lib/apiFetch';
import { HeadContextProvider } from 'src/lib/HeadContext';
import { SocketContextProvider } from 'src/lib/SocketContext';
import { SsrInitDataContext } from 'src/lib/SsrInitDataContext';
import { importPolyfills } from 'src/lib/polyfills/polyfills';
import { createBrowserContext, PrefetchProfilingContextProvider } from 'src/lib/usePrefetch';
import { App } from './App';


if(HOTJAR_SITE_ID) {
  Hotjar.init(HOTJAR_SITE_ID, 6);
}

window.reportClientError = (message) => {
  const code = Math.round(Math.random() * 10000);
  backendApiFetch('/api/errorlog/submit', {
    credentials: 'include',
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      message: message.message || message,
      code,
      stack: message.stack,
    }),
  });
  return code;
};
(async () => {
  await importPolyfills();
  const BrowserDataContext = createBrowserContext();

  const backendApiFetch = createBackendApiFetch(WEBSITE_BACKEND_BASE_URL);

  const AppJSX = (
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    <PrefetchProfilingContextProvider mark={() => {}}>
      <BackendFetchContextProvider value={async (path, init) => {
        const result = await backendApiFetch(path, init);
        if(result.status === 401) {
          const refreshResponse = await fetch('/oauth2/refresh', { credentials: 'include' });
          if(refreshResponse.ok) {
            const data = await refreshResponse.json();
            if(data.success) {
              return backendApiFetch(path, init);
            }
          }
        }
        return result;
      }}>
        <BrowserDataContext>
          <SsrInitDataContext.Provider
            value={{
              ssr: false,
              serverCompactMode: undefined,
              skipMaintenance: undefined,
              hasLoginToken: undefined,
              location: undefined,
            }}
          >
            <HeadContextProvider value={{ isHead: false }}>
              <SocketContextProvider>
                <App/>
              </SocketContextProvider>
            </HeadContextProvider>
          </SsrInitDataContext.Provider>
        </BrowserDataContext>
      </BackendFetchContextProvider>
    </PrefetchProfilingContextProvider>
  );
  if(window.serverSideRenderingError) {
    console.log('ssr error');
    ReactDOMClient.createRoot(document.getElementById('react-root')).render(AppJSX);
  } else {
    ReactDOMClient.hydrateRoot(document.getElementById('react-root'), AppJSX);
  }
})();
